export const redirectConfig = {
    "[OOT_DOMAIN]" : process.env.REACT_APP_OOT,
    "[DM_DOMAIN]" : process.env.REACT_APP_DATAMART,// Placeholder for Datamart domain
};